import { render, staticRenderFns } from "./MedicalVideo.vue?vue&type=template&id=43132ea2&"
import script from "./MedicalVideo.vue?vue&type=script&lang=js&"
export * from "./MedicalVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports